import React from 'react'
import PastEvents from './PastEvents'
import GalleryModal from './GalleryModal'


const SAN_PEDRO_GOOGLE_DRIVE_FOLDER = "1PKgDoMAm6ckGabCY0OJI4Lxwsfw_mHrr"
export default function GalleryPage() {
  const [modalUrl, setModalUrl] = React.useState(null);
  const handleModalClose = () => setModalUrl(null);
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      paddingTop: 20,
      paddingBottom: 20
    }}>
      <div style={{ flex: 1, maxWidth: "1200px", padding: "0 20px" }}>
        <PastEvents setModalUrl={setModalUrl} />
      </div>
      <GalleryModal modalUrl={modalUrl} handleModalClose={handleModalClose}/>
    </div>
  )
}